var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 12,
    viewBox: "0 0 37 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01837 11.7586H5.89657L3.5556 2.56498C3.44448 2.14208 3.20856 1.7682 2.86153 1.59199C1.99546 1.14917 1.04111 0.796744 0 0.619001V0.265047H5.02898C5.72305 0.265047 6.2436 0.796744 6.33036 1.41425L7.54499 8.04591L10.6653 0.265047H13.7003L9.01837 11.7586ZM15.4327 11.7587H12.4844L14.9121 0.265137H17.8604L15.4327 11.7587ZM21.6787 3.44914C21.7654 2.8301 22.286 2.47615 22.8933 2.47615C23.8476 2.38727 24.8872 2.56502 25.7548 3.00631L26.2754 0.531697C25.4078 0.177743 24.4534 0 23.5874 0C20.7258 0 18.6436 1.59203 18.6436 3.80156C18.6436 5.48246 20.1185 6.36504 21.1596 6.89674C22.286 7.42691 22.7198 7.78086 22.633 8.31102C22.633 9.10627 21.7654 9.46023 20.8993 9.46023C19.8582 9.46023 18.8171 9.19514 17.8643 8.75232L17.3438 11.2285C18.3849 11.6698 19.5112 11.8475 20.5523 11.8475C23.7609 11.9348 25.7548 10.3443 25.7548 7.95707C25.7548 4.95076 21.6787 4.77455 21.6787 3.44914ZM36.0721 11.7586L33.7312 0.265047H31.2167C30.6961 0.265047 30.1756 0.619001 30.002 1.14917L25.6671 11.7586H28.7022L29.308 10.0792H33.0371L33.3841 11.7586H36.0721ZM31.6515 3.36035L32.5176 7.69208H30.0898L31.6515 3.36035Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/_VISA.251ce033a9981a00e0b66ce1e0c75d9b.svg";
export { ForwardRef as ReactComponent };